<google-map
  #map
  [height]="'100%'"
  [width]="'100%'"
  [center]="center"
  [zoom]="zoom"
  [options]="mapOptions"
  *ngIf="mapLoaded"
  class="rounded-xl overflow-hidden"
>
  <map-marker
    *ngFor="let marker of markers"
    [position]="marker"
    [icon]="customIcon"
  ></map-marker>
</google-map>
